import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_SUGGEST_REQUEST } from './schema';

const MUTATION = gql`
  mutation SaveImageVariation($originalVariationId: ID!, $encodedImage: String!) {
    saveImageVariation(originalVariationId: $originalVariationId, encodedImage: $encodedImage) {
      ...SuggestionRequest
    }
  }
  ${FRAGMENT_SUGGEST_REQUEST}
`;

export const saveImageVariation = async ({ originalVariationId, encodedImage }) => {
  const variables = {
    originalVariationId,
    encodedImage,
  };

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp(response.data);
};
